/*
 * @Author: Li Xingxing
 * @Email: lixingxing@everimaging.com
 * @Date: 2023-03-31 10:10:29
 * @Description:
 */
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import style from './index.module.scss';

interface type {
  children: any;
  edit?: boolean;
  downLoad?: () => void;
  column: number;
}

const WaterFall = ({ children, column = 2, edit, downLoad }: type) => {
  const [arr, setArr] = useState<any[]>();

  //找到最小
  function getMin(arr: any[] = []) {
    let index = 0;
    let min = 0;
    for (let i = 0, len = arr.length; i < len; i++) {
      if (i === 0) {
        min = arr[i].height;
        continue;
      }
      if (arr[i].height < min) {
        min = arr[i].height;
        index = i;
      }
    }
    return index;
  }
  //标准算比例
  useLayoutEffect(() => {
    const getArr:any = new Array(column).fill([]).map(item => {
      return { imgList: [], height: 0 };
    });
    children?.forEach((item:any) => {
      let index = getMin(getArr);
      if (!item.props?.height || !item.props?.width) {
        return;
      }
      let getRate = Number((item.props.height / item.props.width).toFixed(2));
      getArr[index].imgList.push(item as any);
      getArr[index].height =
        Number((getRate + getArr[index].height).toFixed(2)) || 0;
    });
    setArr(getArr);
  }, [children]);

  const downRef = useRef<HTMLDivElement|null>(null);

  useEffect(() => {
    let observe = new IntersectionObserver(el => {
      if (el[0].isIntersecting) {
        downLoad && downLoad();
      }
    });
    if (downRef.current) {
      observe.observe(downRef.current);
    }
    return () => {
      observe.disconnect();

    };
  }, [arr]);

  return (
    <div className={style['gallery-section-container']}>
      {arr?.map((item, index) => {
        return (
          <div
            key={`${item.taskId}${index}`}
            className={`${style['gallery-waterfall-container']}`}
          >
            {item.imgList.map((items:any, indexs:number) => {
              return (
                <div
                  style={{ marginTop: indexs === 0 ? 0 : '9px' }}
                  key={`${items.key}${index}`}
                >
                  {/* 下拉加载 */}
                  {index === arr?.length - 1 &&
                    indexs === item.imgList.length - 1 && (
                      <div
                        ref={downRef}
                        className="gallery-container-updown-load"
                      ></div>
                    )}
                  {items}
                </div>
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

export default WaterFall;
